import React, {createContext} from 'react';
const ProfileContext = createContext(null);
export {ProfileContext};